import React from 'react'
import { useMediaQuery } from '@mui/material'
import { HomeWrapper } from './StyledComponents'
import LinksSlideshow from '../TCP-HP/LinksSlideShow'
import Header from './Header'
import Hero from './Hero'
import Services from './Services'
import AppDetails from './AppDetails'
import Forms from './Forms'
import Footer from './Footer'
import { useLocation } from 'react-router-dom'

function NewUDHome() {
	const location = useLocation();
	const homepath = location?.pathname?.includes("digit-ui/citizen")
	const isBigScreen = useMediaQuery(theme => theme.breakpoints.up('lg'))
	const isMediumScreen = useMediaQuery('(min-width:900px) and (max-width:1199px)')
	const isSmallScreen = useMediaQuery('(min-width:600px) and (max-width:899px)')

	return (
		<HomeWrapper style={{marginTop: homepath ? '-80px' : '0px'}}>
			<Header />
			<Hero />
			<Services />
			<AppDetails />
			<Forms />
			<LinksSlideshow
				titleStyles={{
					textTransform: 'uppercase',
					fontSize: '1.25rem',
					color: '#0E7693',
					fontWeight: 600,
				}}
				containerStyles={{ maxWidth: 1200 - 48, marginInline: 'auto' }}
				noOfSlides={isBigScreen ? 5 : isMediumScreen ? 3 : isSmallScreen ? 2 : 1}
			/>
			<Footer />
		</HomeWrapper>
	)
}

export default NewUDHome
